module.exports = __webpack_public_path__ + "static/img/category.2318c537.png";